module.exports = __webpack_public_path__ + "static/media/indomaretlogo.231af9b5.png";